// extracted by mini-css-extract-plugin
module.exports = {"shredPopupBanner":"CardsShredPopup_shredPopupBanner__1EeuT","closeButton":"CardsShredPopup_closeButton__3SOq3","popup":"CardsShredPopup_popup__uB7Ew"};